<template>
  <div>
    <vue-portal to="hrsys-navbar-actions">
      <div class="flex">
        <base-header-title :title="$t('users.profile')"/>
      </div>
    </vue-portal>
    <base-loader :loading="loadingData">
      <user-details-component
        :action="process"
        :is-my-profile="true"
        :loading="loading"
        :roles="roles"
        :user="userData"
        @confirm="update">
      </user-details-component>
    </base-loader>
  </div>
</template>

<script>
  import AuthService from '../../services/Auth';
  import Users from "../../services/Users";
  import UserDetailsComponent from "../../components/users/UserDetailsComponent";
  import store from '../../store/store';
  import {ADMIN_ROLE, HR_ROLE} from "../../middlewares/permissions";

  export default {
    name: 'UserDetails',
    components: {
      UserDetailsComponent
    },
    data () {
      return {
        loadingData: false,
        loading: false,
        process: 'update',
        userData: {...store.state.me},
        roles: [],
        userId: null
      }
    },
    methods: {
      update () {
        this.loading = true;
        AuthService.updateProfile(this.userData).then(() => {
          this.$notificationService.success(this.$t('profile.successUpdate'));
          this.loading = false;
          history.back();
        }, e => {
          this.loading = false;
          this.$notificationService.error(e.message);
        });
      },
      getRoles () {
        Users.roles().then((response) => {
          this.roles = response.data
        })
      }
    },
    computed: {
      canManageRole () {
        return AuthService.hasOneOfRoles(ADMIN_ROLE, HR_ROLE);
      },
    },
    mounted () {
      if (this.canManageRole) this.getRoles()
      this.loadingData = true;
      AuthService.me().then(({data}) => {
        this.userData = data;
        this.loadingData = false;
      }, (e) => {
        this.loadingData = false;
        this.$notificationService.error(e.message);
      });
    }
  }
</script>

<style scoped>

</style>
